export interface DebateRound {
  agent?: string;
  summary?: string;
}

interface DebateViewerProps {
  debate?: {
    rounds?: DebateRound[];
    note?: string;
  } | null;
}

export function DebateViewer({ debate }: DebateViewerProps) {
  const rounds = debate?.rounds ?? [];
  if (rounds.length === 0 && !debate?.note) {
    return (
      <p className="text-sm text-gray-500">No debate data for this run yet.</p>
    );
  }
  return (
    <div className="space-y-3">
      <ul className="space-y-2 text-sm text-gray-800">
        {rounds.map((r, i) => (
          <li
            key={i}
            className="rounded-lg border border-gray-200 bg-white p-3 shadow-sm"
          >
            <span className="font-medium text-primary-700">
              {r.agent ?? "agent"}
            </span>
            <p className="mt-1 text-gray-700">{r.summary ?? "—"}</p>
          </li>
        ))}
      </ul>
      {debate?.note ? (
        <p className="text-xs italic text-gray-500">{debate.note}</p>
      ) : null}
    </div>
  );
}
